module.exports = __webpack_public_path__ + "fonts/KFOkCnqEu92Fr1MmgVxIIzQ.5cb7edfc.5cb7edfc.woff";